module.exports = __webpack_public_path__ + "static/media/image-card-4.0923ead7.png";